<template>
  <div class="bigBox">
    <el-aside class="sideMain">
      <el-menu :default-active="defaultMenu" class="side_menu" @open="handleOpen" @close="handleClose" @select="menuEvent" background-color="#252A4F" text-color="#fff" :collapse="isCollapse" active-text-color="#ffffff">
        <div class="logoMainBox">
          <img src="@/assets/img/logo_icon.png" class="logo_icon" alt="">
          <div class="logo_right" v-if="!isCollapse">
            <div class="logo_top">
              消耗表系统
            </div>
            <div class="logo_bottom">新媒体事业部</div>
          </div>
          <!-- <span v-if="!isCollapse">新媒体事业部消耗表系统</span> -->
        </div>
        <div v-for="(item,index) in menuList" :key="index">
          <el-submenu :index="'big'+index" v-if="item.enable == 1 && !item.route">
            <template slot="title">
              <img class="icon" :src="item.icon" alt="">
              <span>{{item.title}}</span>
            </template>
            <el-menu-item :disabled="!it.route" v-if="it.enable == 1" :index="it.route" v-for="(it,ind) in item.child" :key="'child'+ind">{{it.title}}</el-menu-item>
          </el-submenu>
          <el-menu-item :index="item.route" v-if="item.enable == 1 && item.route" :disabled="!item.route">
            <img class="icon" :src="item.icon" alt="">
            <span slot="title">{{item.title}}</span>
          </el-menu-item>
        </div>
      </el-menu>
    </el-aside>
    <div class="rightBox">
      <el-header class="mainContainer">
        <div class="topBox clear">
          <div class="left">
            <i class="el-icon-s-fold openSide" @click="isCollapse = true" v-if="!isCollapse"></i>
            <i class="el-icon-s-unfold openSide" @click="isCollapse = false" v-if="isCollapse"></i>
            <div class="userRole">{{userInfo.real_name}}（{{userInfo.role_name}}）</div>
          </div>
          <div class="right">
            <div class="otherItem">
              <img src="@/assets/img/mine.png" alt="">
              <span>{{userInfo.username}}</span>
            </div>
            <div class="otherItem" style="cursor: pointer;" @click="modifyPasswordFlag=true">
              <img src="@/assets/img/password.png" alt="">
              <span>修改密码</span>
            </div>
            <div class="otherItem" style="cursor: pointer;" @click="loginOut">
              <img src="@/assets/img/unLogin.png" alt="">
              <span>退出系统
                <i class="el-icon-loading" v-if="loginOutLoading"></i>
              </span>
            </div>
          </div>
        </div>
      </el-header>
      <el-main class="ConentContainter">
        <div class="main-content-wrapper">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
        <Footer :fixed="false" />
      </el-main>
    </div>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="modifyPasswordFlag" width="30%" :close-on-click-modal='false' center>
      <div v-loading='resetPasswordLoading'>
        <div class="dialogBox">
          <div class="dialogitem">
            <label>用户名称：</label>
            <el-input placeholder="请输入用户名称" style="width:76%" v-model="userName" size='small' clearable>
            </el-input>
          </div>
          <div class="dialogitem">
            <label>密码：</label>
            <el-input placeholder="请输入密码" style="width:76%" v-model="userPassword" size='small' show-password clearable>
            </el-input>
          </div>
          <div class="dialogitem">
            <label>确认密码：</label>
            <el-input placeholder="请确认密码" style="width:76%" v-model="userRePassword" size='small' show-password clearable>
            </el-input>
          </div>
        </div>
        <div style="text-align:center;margin-top:30px">
          <el-button @click="cancelChangePass" size="mini">取 消</el-button>
          <el-button type="primary" @click="resetPassword" size="mini">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { resetRouter } from '@/router/index.js'
import Footer from '@/components/assembly/Footer.vue'
export default {
  components: {
    Footer
  },
  data () {
    return {
      menuList: [],
      defaultMenu: '/home',
      userInfo: {},
      modifyPasswordFlag: false,
      userName: '',
      userPassword: '',
      userRePassword: '',
      resetPasswordLoading: false,
      loginOutLoading: false,
      isCollapse: false,
    }
  },
  created () {
    this.defaultMenu = this.$route.name;
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'))
    this.menuList = JSON.parse(this.$cookie.getCookie('sideInfo'));
  },
  mounted () {
  },
  methods: {

    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    menuEvent (val) {
      this.$router.push(val)
    },
    loginOut () {
      this.loginOutLoading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.loginOut, {
      }).then((res) => {
        var res = res.data;
        this.loginOutLoading = false;
        if (res && (res.errno == 0 || res.errno == '4001' || res.errno == '4002')) {
          this.$message({
            message: '退出成功！',
            type: 'success'
          })
          this.$cookie.delAllCookie();
          this.$router.replace('/login')
          resetRouter();//路由重置
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loginOutLoading = false
      })
    },
    resetPassword () {//修改密码
      if (this.userPassword == '') {
        this.$message({
          message: '请输入新密码',
          type: 'fail'
        })
      }
      if (this.userRePassword == '') {
        this.$message({
          message: '请确认密码',
          type: 'fail'
        })
      }
      if (this.userRePassword != this.userPassword) {
        this.$message({
          message: '确认密码失败',
          type: 'fail'
        })
      }
      this.resetPasswordLoading = true
      this.$axios.post(this.URL.BASEURL + this.URL.resetPassword, {
        password: this.userPassword,
        re_password: this.userRePassword
      }).then((res) => {
        var res = res.data;
        this.resetPasswordLoading = false
        if (res && res.errno == 0) {
          this.$message({
            message: '修改成功！',
            type: 'success'
          })
          this.cancelChangePass()
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.resetPasswordLoading = false
      })
    },
    cancelChangePass () {//取消修改密码
      this.userName = '';
      this.userPassword = '';
      this.userRePassword = '';
      this.modifyPasswordFlag = false;
    }
  },
  watch: {
    $route (to, name) {
      this.defaultMenu = to.name
    },
  }
}
</script>
<style lang="scss" scoped>
.bigBox {
  display: flex;
  width: calc(100vw - 9px);
  overflow: hidden;
  box-sizing: border-box;
  .rightBox {
    width: calc(100vw - 280px);
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
}
.sideMain {
  // width: 185px;
  width: auto !important;
  height: 100vh;
  overflow-y: auto;
  background: #252a4f;
  // float: left;
  &::-webkit-scrollbar {
    width: 2px;
  }
  .logoMainBox {
    width: 180px;
    height: 60px;
    padding-left: 20px;
    padding-top: 6px;
    display: flex;
    align-items: center;
    color: #fff;
    cursor: pointer;
    .logo_icon {
      width: 35px;
      vertical-align: middle;
      display: inline-block;
    }
    span {
      color: #ffffff;
      font-size: 15px;
      font-weight: bold;
      line-height: 20px;
    }
  }
  .logo_right {
    margin-left: 7px;
    flex: 1;
    .logo_top {
      font-weight: bolder;
      line-height: 24px;
      font-size: 17px;
      display: flex;
      align-items: center;
    }
    .logo_top span {
      display: inline-block;
      width: 43px;
      height: 17px;
      line-height: 17px;
      text-align: center;
      border-radius: 3px;
      background: #fe2c00;
      margin-left: 3px;
      font-size: 12px;
    }
    .logo_bottom {
      line-height: 17px;
      font-size: 12px;
      letter-spacing: 1px;
      color: rgba(255, 255, 255, 0.6);
    }
  }
  .icon {
    width: 20px;
    display: inline-block;
  }
}
.mainContainer {
  position: relative;
  z-index: 2;
  // float: right;
  // min-width: 1095px;
  // width: calc(100% - 185px);
  padding: 0;
  .topBox {
    width: 100%;
    height: 60px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    .left {
      float: left;
      margin-left: 18px;
      height: 100%;
      .openSide {
        font-size: 19px;
        cursor: pointer;
      }
      .userRole {
        display: inline-block;
        height: 33px;
        background: #989eb9;
        border-radius: 17px;
        color: #ffffff;
        font-size: 14px;
        line-height: 33px;
        padding: 0 14px;
        margin-top: 13px;
        margin-left: 16px;
        &::before {
          content: "";
          display: inline-block;
          width: 9px;
          height: 9px;
          background: #ffffff;
          border-radius: 5px;
          margin-right: 8px;
        }
      }
    }
    .right {
      float: right;
      line-height: 60px;
      height: 100%;
      .otherItem {
        display: inline-block;
        vertical-align: middle;
        margin-right: 50px;
        img {
          height: 16px;
          display: inline-block;
          vertical-align: middle;
        }
        span {
          color: #3b3f52;
          font-size: 14px;
        }
      }
    }
  }
}
.ConentContainter {
  padding: 0 0 0 10px !important;
  padding-left: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  .main-content-wrapper {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    &::-webkit-scrollbar {
      width: 4px;
    }
  }
}

.dialogitem {
  margin-bottom: 20px;
  label {
    display: inline-block;
    width: 80px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
  }
}
.side_menu:not(.el-menu--collapse) {
  width: 180px;
}
</style>
<style lang="scss">
.sideMain {
  .el-menu-item,
  .el-submenu__title {
    height: 48px;
    line-height: 48px;
  }
  .side_menu {
    border-right: none;
  }
  .el-menu-item.is-active {
    background-color: #4565d6 !important;
  }
  .el-submenu__title.is-active {
    background: #4565d6 !important;
  }
  // .el-menu-item:hover{
  //     background: #6db6ff !important;
  // }
  // .el-submenu__title:hover {
  //     background: #6db6ff !important;
  // }
  .el-menu--collapse .el-submenu {
    span,
    i {
      opacity: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue